import React from 'react';
import useOptimizedConfig from '@/hooks/useOptimizedConfig';
import {FormattedDateTime} from '@/components/utils/FormattedDateTime';
import CellLoader from '@/components/loading/CellLoader';
import {Tooltip} from '@/components/tooltips';
import {truncate} from 'utils/text';
import i18n from 'i18n';
import {useStoreState} from 'store';


const HeaderUser = React.memo(() => {
    const {userData, loading: loadingUserData} = useOptimizedConfig();
    const appConfig = useStoreState((state) => state.appConfigs.items);

    let headerUserDisplay;

    let truncateEmail;
    if (userData?.email) {
        truncateEmail = truncate(userData.email, 30);
    } else {
        truncateEmail = i18n.t('hd_loading.text');
    }

    if (!loadingUserData) {
        headerUserDisplay = (
            <div className="dw-user-box">
                <div className="u-text">
                    <h6>{i18n.t('hd_logged_in_as.text')}</h6>
                    <Tooltip content={userData?.email || ''} placement="bottom">
                        <p className="text-muted">{truncateEmail}</p>
                    </Tooltip>
                    <small>
                        {`${i18n.t('hd_last_login.text')} `}
                        <FormattedDateTime
                            dateTime={userData?.lastLogin}
                            showTime={false}
                            options={{setZone: false}}
                        />
                    </small>
                </div>
            </div>
        );
    } else {
        headerUserDisplay = (<CellLoader />);
    }

    return (
        <>
            {headerUserDisplay}
        </>
    );
});

export default HeaderUser;
